module.exports = __webpack_public_path__ + "prod/20250417163640/img/logo_200.6488dd39.png";